import type { ISettingMaster, ISettingValue } from "@bbj-types/setting";
import { useMemo } from "react";

export const useFilterDisabledSettings = (settings: ISettingValue[] | undefined, currentValue?: string) => {
  return useMemo(() => {
    if (!settings) return [];
    const filteredSettings = settings.filter((v) => v.active !== false);
    if (currentValue) {
      const currentSetting = settings.find((v) => v.value === currentValue);
      if (currentSetting?.active === false) {
        filteredSettings.unshift({
          ...currentSetting,
          label: `${currentSetting.label} (désactivé)`,
        });
      }
    }
    return filteredSettings;
  }, [settings, currentValue]);
};

export const useFilterDisabledSettingsV2 = (settings: ISettingMaster | undefined, currentValue?: string | string[]) => {
  return useMemo(() => {
    if (!settings) return [];
    const filteredSettings = settings.values.filter((v) => v.active !== false);
    if (currentValue && typeof currentValue === "string") {
      const currentSetting = settings.values.find((v) => v.value === currentValue);
      if (currentSetting?.active === false) {
        filteredSettings.unshift({
          ...currentSetting,
          label: `${currentSetting.label} (désactivé)`,
        });
      }
    } else if (Array.isArray(currentValue)) {
      for (const val of currentValue) {
        const currentSetting = settings.values.find((v) => v.value === val);
        if (currentSetting?.active === false) {
          filteredSettings.unshift({
            ...currentSetting,
            label: `${currentSetting.label} (désactivé)`,
          });
        }
      }
    }
    return filteredSettings;
  }, [settings, currentValue]);
};
